import * as Types from '../../../generated/graphql';

import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment = (
  { __typename: 'CircleCheckboxQuestionNode' }
  & Pick<Types.CircleCheckboxQuestionNode, 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment = (
  { __typename: 'CircleDropdownQuestionNode' }
  & Pick<Types.CircleDropdownQuestionNode, 'questionText' | 'required' | 'id'>
  & { options: Array<(
    { __typename: 'CircleAnswerDropdownOptionNode' }
    & Pick<Types.CircleAnswerDropdownOptionNode, 'id' | 'optionText'>
  )> }
);

export type CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment = (
  { __typename: 'CircleParagraphQuestionNode' }
  & Pick<Types.CircleParagraphQuestionNode, 'maxCharacters' | 'lines' | 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment = (
  { __typename: 'CircleRadioGroupQuestionNode' }
  & Pick<Types.CircleRadioGroupQuestionNode, 'questionText' | 'required' | 'id'>
  & { options: Array<(
    { __typename: 'CircleAnswerRadioOptionNode' }
    & Pick<Types.CircleAnswerRadioOptionNode, 'id' | 'optionText'>
  )> }
);

export type CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment = (
  { __typename: 'CircleSingleLineQuestionNode' }
  & Pick<Types.CircleSingleLineQuestionNode, 'maxCharacters' | 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestionFragment = CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment | CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment | CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment | CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment | CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment;

export type CircleTopicFragment = (
  { __typename: 'CircleTopicNode' }
  & Pick<Types.CircleTopicNode, 'id' | 'name' | 'uuid' | 'slug' | 'description' | 'note' | 'format' | 'duration' | 'languageCode'>
  & { facilitators: (
    { __typename: 'CircleFacilitatorConnection' }
    & Pick<Types.CircleFacilitatorConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename: 'CircleFacilitatorEdge' }
      & { node: (
        { __typename: 'CircleFacilitatorNode' }
        & Pick<Types.CircleFacilitatorNode, 'photo' | 'name' | 'credential' | 'country' | 'id'>
      ) }
    )>> }
  ), rsvpQuestions: Array<Types.Maybe<(
    { __typename: 'CircleRadioGroupQuestionNode' }
    & CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment
  ) | (
    { __typename: 'CircleDropdownQuestionNode' }
    & CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment
  ) | (
    { __typename: 'CircleSingleLineQuestionNode' }
    & CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment
  ) | (
    { __typename: 'CircleParagraphQuestionNode' }
    & CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment
  ) | (
    { __typename: 'CircleCheckboxQuestionNode' }
    & CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment
  )>>, series: (
    { __typename: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'uuid' | 'name' | 'accessType'>
  ), sessions: (
    { __typename: 'CircleSessionConnection' }
    & Pick<Types.CircleSessionConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename: 'CircleSessionEdge' }
      & { node: (
        { __typename: 'CircleSessionNode' }
        & Pick<Types.CircleSessionNode, 'id' | 'startTime' | 'rsvpLink' | 'bookingStatus'>
        & { facilitators: Array<Types.Maybe<(
          { __typename: 'CircleFacilitatorNode' }
          & Pick<Types.CircleFacilitatorNode, 'photo' | 'name' | 'credential'>
        )>> }
      ) }
    )>> }
  ) }
);

export type FetchTopicQueryVariables = Types.Exact<{
  topicSlug: Types.Scalars['String'];
}>;


export type FetchTopicQuery = (
  { __typename: 'Query' }
  & { circleTopicBySlug?: Types.Maybe<(
    { __typename: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'id'>
    & CircleTopicFragment
  )> }
);

export type GetCalendarLinksQueryVariables = Types.Exact<{
  rsvpId: Types.Scalars['ID'];
}>;


export type GetCalendarLinksQuery = (
  { __typename: 'Query' }
  & { circleCalendarLinksByRsvp?: Types.Maybe<(
    { __typename: 'CircleCalendarLinks' }
    & Pick<Types.CircleCalendarLinks, 'google' | 'outlook' | 'ics'>
  ) | (
    { __typename: 'CircleNotFoundError' }
    & Pick<Types.CircleNotFoundError, 'message'>
  ) | { __typename: 'CircleValidationError' }> }
);

export const CircleRsvpQuestionFragmentDoc = gql`
    fragment CircleRsvpQuestion on CircleBaseQuestion {
  __typename
  questionText
  required
  id
  ... on CircleCheckboxQuestionNode {
    __typename
  }
  ... on CircleDropdownQuestionNode {
    options {
      ... on CircleAnswerDropdownOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleParagraphQuestionNode {
    maxCharacters
    lines
  }
  ... on CircleRadioGroupQuestionNode {
    options {
      ... on CircleAnswerRadioOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleSingleLineQuestionNode {
    maxCharacters
  }
}
    `;
export const CircleTopicFragmentDoc = gql`
    fragment CircleTopic on CircleTopicNode {
  id
  name
  uuid
  slug
  description
  note
  format
  duration
  languageCode
  facilitators {
    edges {
      node {
        photo
        name
        credential
        country
        id
      }
    }
    totalCount
  }
  rsvpQuestions {
    ...CircleRsvpQuestion
  }
  series {
    id
    uuid
    name
    accessType
  }
  sessions(first: 100) {
    totalCount
    edges {
      node {
        id
        startTime
        rsvpLink
        bookingStatus
        facilitators {
          photo
          name
          credential
        }
      }
    }
  }
}
    ${CircleRsvpQuestionFragmentDoc}`;
export const FetchTopicDocument = gql`
    query fetchTopic($topicSlug: String!) {
  circleTopicBySlug(slug: $topicSlug) {
    id
    ...CircleTopic
  }
}
    ${CircleTopicFragmentDoc}`;

/**
 * __useFetchTopicQuery__
 *
 * To run a query within a React component, call `useFetchTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTopicQuery({
 *   variables: {
 *      topicSlug: // value for 'topicSlug'
 *   },
 * });
 */
export function useFetchTopicQuery(baseOptions: Apollo.QueryHookOptions<FetchTopicQuery, FetchTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTopicQuery, FetchTopicQueryVariables>(FetchTopicDocument, options);
      }
export function useFetchTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTopicQuery, FetchTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTopicQuery, FetchTopicQueryVariables>(FetchTopicDocument, options);
        }
export type FetchTopicQueryHookResult = ReturnType<typeof useFetchTopicQuery>;
export type FetchTopicLazyQueryHookResult = ReturnType<typeof useFetchTopicLazyQuery>;
export type FetchTopicQueryResult = Apollo.QueryResult<FetchTopicQuery, FetchTopicQueryVariables>;
export const GetCalendarLinksDocument = gql`
    query getCalendarLinks($rsvpId: ID!) {
  circleCalendarLinksByRsvp(rsvpId: $rsvpId) {
    __typename
    ... on CircleCalendarLinks {
      google
      outlook
      ics
    }
    ... on CircleNotFoundError {
      message
    }
  }
}
    `;

/**
 * __useGetCalendarLinksQuery__
 *
 * To run a query within a React component, call `useGetCalendarLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarLinksQuery({
 *   variables: {
 *      rsvpId: // value for 'rsvpId'
 *   },
 * });
 */
export function useGetCalendarLinksQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarLinksQuery, GetCalendarLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarLinksQuery, GetCalendarLinksQueryVariables>(GetCalendarLinksDocument, options);
      }
export function useGetCalendarLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarLinksQuery, GetCalendarLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarLinksQuery, GetCalendarLinksQueryVariables>(GetCalendarLinksDocument, options);
        }
export type GetCalendarLinksQueryHookResult = ReturnType<typeof useGetCalendarLinksQuery>;
export type GetCalendarLinksLazyQueryHookResult = ReturnType<typeof useGetCalendarLinksLazyQuery>;
export type GetCalendarLinksQueryResult = Apollo.QueryResult<GetCalendarLinksQuery, GetCalendarLinksQueryVariables>;